import * as types from 'src/state/ducks/master/types';
import { Actions } from 'src/state/ducks/master/actions';
import { TagEntity } from 'src/firebase/db/Tags';
import { MessageEntity, messageInitialEntity } from 'src/firebase/db/Messages';

import { ValidationResponse } from 'src/firebase/db/ValidationManager';
import { APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';

export interface State {
  isFetching: boolean;
  tags: TagEntity[];
  validationErrors: ValidationResponse['errors'];
  apiError: APIFailedResponse['error'] | undefined;
  messages: MessageEntity[];
  message: {
    isFetching: boolean;
    draft: MessageEntity;
    validationErrors: ValidationResponse['errors'];
    apiError: APIFailedResponse['error'] | undefined;
  };
}

const initialState: State = {
  isFetching: false,
  tags: [],
  validationErrors: {},
  apiError: undefined,
  messages: [],
  message: {
    isFetching: false,
    draft: messageInitialEntity,
    validationErrors: {},
    apiError: undefined,
  },
};

const masterReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case types.GET_TAGS: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_GET_TAGS: {
      return {
        ...state,
        isFetching: false,
        tags: action.payload.data,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_GET_TAGS: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.CREATE_TAG: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_CREATE_TAG: {
      return {
        ...state,
        tags: [...state.tags, action.payload.data],
        isFetching: false,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_CREATE_TAG: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.UPDATE_TAG: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case types.SUCCESS_UPDATE_TAG: {
      return {
        ...state,
        tags: [
          ...state.tags.filter((tag) => tag.id !== action.payload.data.id),
          action.payload.data,
        ],
        isFetching: false,
        validationErrors: {},
        apiError: undefined,
      };
    }

    case types.FAIL_UPDATE_TAG: {
      return {
        ...state,
        isFetching: false,
        validationErrors: 'errors' in action.payload ? action.payload.errors : {},
        apiError: 'error' in action.payload ? action.payload.error : undefined,
      };
    }

    case types.CREATE_PUSH_MESSAGE: {
      return {
        ...state,
        message: {
          ...state.message,
          isFetching: true,
          draft: action.payload,
        },
      };
    }

    case types.SUCCESS_PUSH_MESSAGE: {
      return {
        ...state,
        messages: [...state.messages, action.payload.data],
        message: {
          isFetching: false,
          draft: messageInitialEntity,
          validationErrors: {},
          apiError: undefined,
        },
      };
    }

    case types.FAIL_PUSH_MESSAGE: {
      return {
        ...state,
        message: {
          ...state.message,
          isFetching: false,
          validationErrors: 'errors' in action.payload ? action.payload.errors : {},
          apiError: 'error' in action.payload ? action.payload.error : undefined,
        },
      };
    }

    case types.INIT_MASTER: {
      return initialState;
    }

    default:
      return state;
  }
};

export default masterReducer;
